<template>
  <fieldset>
    <CheckboxWithLabel
      :classNames="classNames"
      label="Enable as LDAP Bind DN"
      name="ldap_binding_user"
      :tooltip="{
        text: $options.tooltip.ldap.text,
      }"
      :value="parent.ldap_binding_user"
      @change="handleLdapBindingUserClick"
    />
    <Modal
      v-model="modalVisible"
      cancelText="cancel"
      :handleMainAction="handleModalMainAction"
      headerText="LDAP Bind DN"
      mainActionText="continue"
    >
      <p>
        By enabling this user as a Bind DN, they will also be enabled on the
        JumpCloud LDAP Directory.
      </p>
    </Modal>
  </fieldset>
</template>
<script>
import { DirectoryTypeConsts, ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import { notify } from 'client/util/index';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import CheckboxWithLabel from 'client/components/FormValidation/CheckboxWithLabel';
import Modal from 'client/components/Modal/Modal.vue';

const storeModule = StoreModuleMap[ItemTypeConsts.directory];

export default {
  name: 'LdapBindDnInput',

  components: {
    CheckboxWithLabel,
    Modal,
  },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  props: {
    classNames: {
      required: false,
      type: Object,
      default: () => ({ input: '', label: '' }),
    },
  },

  data() {
    return {
      modalVisible: false,
    };
  },

  computed: {
    ...mapGetters(storeModule, [
      'getLdap',
      'isItemDirectlyBound',
      'isItemPreviouslyDirectlyBound',
      'isItemSelected',
    ]),
  },

  tooltip: {
    ldap: {
      text: 'Allows user to bind to and search the JumpCloud LDAP service.',
    },
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options, true);
  },

  mounted() {
    this.fetchDirectoryCollection();
  },

  methods: {
    ...mapActions(storeModule, [
      'createDirectBinding',
      'restorePreviousDirectBinding',
      'selectItem',
    ]),

    ...mapActions('DirectoryCollection', {
      fetchDirectoryCollection: 'fetchCollection',
    }),

    handleLdapBindingUserClick(checked) {
      if (checked) {
        const ldap = this.getLdap;

        if ((this.isParentBeingUpdated && !this.isItemDirectlyBound(ldap.id))
            || (this.isParentBeingCreated && !this.isItemSelected(ldap.id))) {
          this.modalVisible = true;
        } else {
          this.setParentField({ key: 'ldap_binding_user', value: true });
        }
      } else {
        this.setParentField({ key: 'ldap_binding_user', value: false });
      }
    },

    handleModalMainAction() {
      const ldap = this.getLdap;
      const hideModalAndSetParentField = () => {
        this.setParentField({ key: 'ldap_binding_user', value: true });
        this.modalVisible = false;
      };

      // TODO: The logic to restore a previous direct binding or create a new
      // one has been duplicated from the SudoStatus component and should be
      // moved to the createDirectBinding() action.

      if (this.isParentBeingCreated) {
        this.selectItem({ id: ldap.id });
        hideModalAndSetParentField();
      } else if (this.isItemPreviouslyDirectlyBound(ldap.id)) {
        this.restorePreviousDirectBinding(ldap.id);
        hideModalAndSetParentField();
      } else {
        this
          .createDirectBinding({
            parentType: this.parentType,
            parentId: this.parent._id,
            targetType: DirectoryTypeConsts.ldapServer,
            targetId: ldap.id,
          })
          .then(() => {
            this.selectItem({ id: ldap.id });
            hideModalAndSetParentField();
          })
          .catch(() => {
            this.modalVisible = false;
            notify('error', 'Unable to create direct binding!');
          });
      }
    },
  },
};
</script>
<style module>
@value (fontHeight) from '~components/FormValidation/css/formFields.css';

.icon {
  font-size: fontHeight;
}
</style>
